import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { Slices } from './types.ts';
import { ihutReducer, notificationsReducer } from './slices/index.ts';

const rootReducer = combineReducers({
  [Slices.IHUT]: ihutReducer,
  [Slices.NOTIFICATIONS]: notificationsReducer
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    reducer: rootReducer,
    preloadedState
  });

const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export default store;
